export interface IRoutesNames {
  customer: string[];
  store: string[];
  company: string[];
  admin: string[];
}

const routesNames: Readonly<IRoutesNames> = {
  customer: ["customerLogin", "customer"],
  store: ["customerLogin", "store"],
  company: ["companyLogin", "company"],
  admin: ["adminLogin", "admin"],
};

export const STORE_ROUTER_NAMES = {
  home: routesNames.store[1],
  login: routesNames.store[0],
  detailCategory: "detailCategory",
  categoryTranslation: "categoryTranslation",
  changePassword: "storeChangePassword",
  changeEmail: "storeChangeEmail",
  createProduct: "createProduct",
  productDetailRegistrationTwo: "productDetailRegistrationTwo",
  modalTargetProduct: "modalTargetProduct",
  productRegistrationMultilingual: "productRegistrationMultilingual",
  modalProductVariationRegistration: "modalProductVariationRegistration",
  modalProductVariationRegistrationTwo: "modalProductVariationRegistrationTwo",
  registerBag: "registerBag",
  modalTargetProductSelection: "modalTargetProductSelection",
  modalSetProductTarget: "modalSetProductTarget",
  productRegistrationBundle: "productRegistrationBundle",
  bundleProduct: "bundleProduct",
  modalEligibleProductSelection: "modalEligibleProductSelection",
  modalBundleProductTarget: "modalBundleProductTarget",
  saleSetting: "saleSetting",
  saleDetailsSetting: "saleDetailsSettings",
  modalSaleTargetProductSelectionCategory:
    "modalSaleTargetProductSelectionCategory",
  modalSaleTargetProductSelectionIndividual:
    "modalSaleTargetProductSelectionIndividual",
  modalSaleTargetStoreSettings: "modalSaleTargetStoreSettings",
  couponSetting: "couponSetting",
  addCoupon: "addCoupon",
  modalCouponTargetProductSelectionCategory:
    "modalCouponTargetProductSelectionCategory",
  modalCouponEligibleProductSelectionProduct:
    "modalCouponEligibleProductSelectionProduct",
  modalCouponEligibleStoreSettings: "modalCouponEligibleStoreSettings",
  cashRegister: "cashRegister",
  cashRegisterDetail: "cashRegisterDetail",
  cashRegisterCreate: "cashRegisterCreate",
  cashDrawerRegistration: "cashDrawerRegistration",
  automaticChangeSetting: "automaticChangeSetting",
  rfidReaderRegistration: "rfidReaderRegistration",
  receiptPrinterRegistration: "receiptPrinterRegistration",
  paymentTypeSetting: "paymentTypeSetting",
  paymentMethodSetting: "paymentMethodSetting",
  depositCategoryRegistration: "depositCategoryRegistration",
  withdrawalClassificationRegistration: "withdrawalClassificationRegistration",
  inventoryManagement: "inventoryManagement",
  receiptSetting: "receiptSetting",
  masterSetting: "storeMasterSetting",
  salesAnalysis: "salesAnalysis",
  salesAnalysisByProduct: "salesAnalysisByProduct",
  salesByStore: "salesByStore",
  transactionHistoryList: "transactionHistoryList",
  transactionHistoryDetail: "transactionHistoryDetail",
  transactionHistoryEdit: "transactionHistoryEdit",
  depositWithdrawalHistory: "depositWithdrawalHistory",
  cashRegisterInspectionHistory: "cashRegisterInspectionHistory",
  cashRegisterInspectionHistoryDetail:
    "cashRegisterInspectionPaymentHistoryDetail",
  billingList: "storeBillingList",
  accountSetting: "storeAccountSetting",
  listProduct: "listProduct",
  detailProduct: "detailProduct",
  storeResetPassword: "storeResetPassword",
};

export const COMPANY_ROUTER_NAMES = {
  home: routesNames.company[1],
  login: routesNames.company[0],
  listStore: "company_listStore",
  createStore: "company_createStore",
  detailStore: "company_detailStore",
  storeGroup: "storeGroup",
  listPermission: "listPermission",
  detailPermission: "detailPermission",
  staffRegistrationDetail: "staffRegistrationDetail",
  changeRegisteredInformation: "changeRegisteredInformation",
  accountSetting: "company_accountSetting",
  changePassword: "company_changePassword",
  changeEmail: "company_changeEmail",
  registerBag: "company_registerBag",
  detailCategory: "company_detailCategory",
  listCategory: "company_listCategory",
  createProduct: "company_createProduct",
  detailProduct: "company_detailProduct",
  listProduct: "company_listProduct",
  listSetProduct: "listSetProduct",
  detailSetProduct: "detailSetProduct",
  listBundleProduct: "listBundleProduct",
  detailBundleProduct: "detailBundleProduct",
  companyPlan: "companyPlan",
  paymentTypeSetting: "paymentTypeSetting",
  depositCategoryRegistration: "depositCategoryRegistration",
  paymentMethodSetting: "paymentMethodSetting",
  withdrawalClassificationRegistration: "withdrawalClassificationRegistration",
  masterSetting: "masterSettingCompany",
  receiptSetting: "receiptSetting",
  saleSetting: "saleSetting",
  saleDetailsSetting: "saleDetailsSettings",
  saleDetailsSettingModal: "saleDetailsSettingsModal",
  couponSetting: "couponSetting",
  addCoupon: "addCoupon",
};

export default routesNames;
